/**
 * @description 路由路徑宣告
 */
export enum ROUTES {
  /** 首頁 (module) */
  HOME = '',
  /** 首頁-主首頁 (page) */
  HOME__MAIN = '/',
  /** 首頁-旅遊險 (page) */
  HOME__TRAVEL_INSURANCE = '/travel-insurance',
  /** 首頁-定期壽險 (page) */
  HOME__LIFE_INSURANCE = '/life-insurance',
  /** 首頁-網站導覽 */
  HOME__SITE_MAP = '/site-map',

  /** 線上投保 (module) */
  ONLINE_INSURE = '/online-insure',
  /** 線上投保-旅平險 (module) */
  ONLINE_INSURE__TRAVEL_INSURANCE = '/online-insure/travel-insurance',
  /** 線上投保-旅平險-計算保費 (Step-1) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__CALCULATION = '/online-insure/travel-insurance/calculation',
  /** 線上投保-旅平險-填寫資料 (Step-2-1) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__INSURANCE_INFO = '/online-insure/travel-insurance/insurance-info',
  /** 線上投保-旅平險-填寫資料 (Step-2-2) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__INSURANCE_INFO__CLAUSES = '/online-insure/travel-insurance/insurance-info/clauses',
  /** 線上投保-旅平險-確認資料 (Step-3-1) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__CONFIRM_INFO = '/online-insure/travel-insurance/confirm-info',
  /** 線上投保-旅平險-確認資料 (Step-3-2) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__CONFIRM_INFO__OTP_AUTH = '/online-insure/travel-insurance/confirm-info/otp-auth',
  /** 線上投保-旅平險-線上繳費/繳費方式 (Step-4-1) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT = '/online-insure/travel-insurance/payment',
  /** 線上投保-旅平險-線上繳費/信用卡 (Step-4-2) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT__CREDIT_CARD = '/online-insure/travel-insurance/payment/credit-card',
  /** 線上投保-旅平險-線上繳費/帳戶轉帳 (Step-4-2) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT__TRANSFER = '/online-insure/travel-insurance/payment/transfer',
  /** 線上投保-旅平險-完成投保 (Step-5) (page) */
  ONLINE_INSURE__TRAVEL_INSURANCE__COMPLETE = '/online-insure/travel-insurance/complete',

  /** 線上投保-旅平險 (module) */
  ONLINE_INSURE__LIFE_INSURANCE = '/online-insure/life-insurance',
  /** 線上投保-旅平險-計算保費 (Step-1) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__CALCULATION = '/online-insure/life-insurance/calculation',
  /** 線上投保-旅平險-填寫資料 (Step-2-1) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__INSURANCE_INFO = '/online-insure/life-insurance/insurance-info',
  /** 線上投保-旅平險-填寫資料 (Step-2-2) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__INSURANCE_INFO__CLAUSES = '/online-insure/life-insurance/insurance-info/clauses',
  /** 線上投保-旅平險-確認資料 (Step-3-1) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__CONFIRM_INFO = '/online-insure/life-insurance/confirm-info',
  /** 線上投保-旅平險-確認資料 (Step-3-2) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__CONFIRM_INFO__OTP_AUTH = '/online-insure/life-insurance/confirm-info/otp-auth',
  /** 線上投保-旅平險-線上繳費/繳費方式 (Step-4-1) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__PAYMENT = '/online-insure/life-insurance/payment',
  /** 線上投保-旅平險-線上繳費/信用卡 (Step-4-2) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__PAYMENT__CREDIT_CARD = '/online-insure/life-insurance/payment/credit-card',
  /** 線上投保-旅平險-線上繳費/帳戶轉帳 (Step-4-2) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__PAYMENT__TRANSFER = '/online-insure/life-insurance/payment/transfer',
  /** 線上投保-旅平險-完成投保 (Step-5) (page) */
  ONLINE_INSURE__LIFE_INSURANCE__COMPLETE = '/online-insure/life-insurance/complete',

  /** 保險服務 (module) */
  SERVICE = '/service',
  /** 保險服務-保單查詢 (module) */
  SERVICE__QUERY_POLICY = '/service/query-policy',
  /** 保險服務-保單查詢-列表 (page) */
  SERVICE__QUERY_POLICY__LIST = '/service/query-policy/list',
  /** 保險服務-保單查詢-明細 (page) */
  SERVICE__QUERY_POLICY__DETAIL = '/service/query-policy/detail/:policyNo',
  SERVICE__QUERY_POLICY_PROTECT__DETAIL = '/service/query-policy/protect/detail/:policyNo',
  SERVICE__QUERY_POLICY_PROTECT__NOTE = '/service/query-policy/protect/note',
  /** 保險服務-保單查詢-明細-取消投保 (page) */
  SERVICE__QUERY_POLICY__DETAIL__CANCEL = '/service/query-policy/detail/:policyNo/cancel',
  /** 保險服務-保單查詢-我要繳費 (module) */
  SERVICE__QUERY_POLICY__PAY = '/service/query-policy/pay',
  /** 保險服務-保單查詢-我要繳費-確認資料 (Step-1-1) (page) */
  SERVICE__QUERY_POLICY__PAY__CONFIRM_INFO = '/service/query-policy/pay/confirm-info',
  /** 保險服務-保單查詢-我要繳費-確認資料 (Step-1-2) (page) */
  SERVICE__QUERY_POLICY__PAY__CONFIRM_INFO__OTP_AUTH = '/service/query-policy/pay/confirm-info/otp-auth',
  /** 保險服務-保單查詢-我要繳費-線上繳費/繳費方式 (Step-2-1) (page) */
  SERVICE__QUERY_POLICY__PAY__PAYMENT = '/service/query-policy/pay/payment',
  /** 保險服務-保單查詢-我要繳費-線上繳費/信用卡 (Step-2-2) (page) */
  SERVICE__QUERY_POLICY__PAY__PAYMENT__CREDIT_CARD = '/service/query-policy/pay/payment/credit-card',
  /** 保險服務-保單查詢-我要繳費-線上繳費/帳戶轉帳 (Step-2-2) (page) */
  SERVICE__QUERY_POLICY__PAY__PAYMENT__TRANSFER = '/service/query-policy/pay/payment/transfer',
  /** 保險服務-保單查詢-我要繳費-線上繳費/繳費完成、繳費失敗 (Step-3) (page) */
  SERVICE__QUERY_POLICY__PAY__RESULT = '/service/query-policy/pay/result',
  /** 保險服務-保單查詢-改期 (module) */
  SERVICE__QUERY_POLICY__MODIFY = '/service/query-policy/modify',
  /** 保險服務-保單查詢-改期-修改保期 (Step-1) (page) */
  SERVICE__QUERY_POLICY__MODIFY__POLICY_INFO = '/service/query-policy/modify/policy-info',
  /** 保險服務-保單查詢-改期-確認資料 (Step-2-1) (page) */
  SERVICE__QUERY_POLICY__MODIFY__CONFIRM_INFO = '/service/query-policy/modify/confirm-info',
  /** 保險服務-保單查詢-改期-確認資料 (Step-2-2) (page) */
  SERVICE__QUERY_POLICY__MODIFY__CONFIRM_INFO__OTP_AUTH = '/service/query-policy/modify/confirm-info/otp-auth',
  /** 保險服務-保單查詢-改期-線上繳費/信用卡 (Step-3) (page) */
  SERVICE__QUERY_POLICY__MODIFY__PAYMENT__CREDIT_CARD = '/service/query-policy/modify/payment/credit-card',
  /** 保險服務-保單查詢-改期-線上繳費/帳戶轉帳 (Step-3) (page) */
  SERVICE__QUERY_POLICY__MODIFY__PAYMENT__TRANSFER = '/service/query-policy/modify/payment/transfer',
  /** 保險服務-保單查詢-改期-修改完成 (Step-4) (page) */
  SERVICE__QUERY_POLICY__MODIFY__RESULT = '/service/query-policy/modify/result',
  /** 保險服務-申請英文投保證明 */
  SERVICE__APPLY_CERTEN = '/service/apply-certen',

  /** 會員中心 (module) */
  MEMBER = '/member',
  /** 會員中心-會員註冊 (module) */
  MEMBER__REGISTER = '/member/register',
  /** 會員中心-會員註冊-身分驗證 (Step-1) (page) */
  MEMBER__REGISTER__AUTH = '/member/register/auth',
  /** 會員中心-會員註冊-一般註冊 (module) */
  MEMBER__REGISTER__GENERAL = '/member/register/general',
  /** 會員中心-會員註冊-一般註冊-同意相關告知事項 (Step-1) (page) */
  MEMBER__REGISTER__GENERAL__CLAUSES = '/member/register/general/clauses',
  /** 會員中心-會員註冊-一般註冊-填寫資料 (Step-2) (page) */
  MEMBER__REGISTER__GENERAL__PERSONAL_INFO = '/member/register/general/personal-info',
  /** 會員中心-會員註冊-一般註冊-確認資料 (Step-3-1) (page) */
  MEMBER__REGISTER__GENERAL__CONFIRM_INFO = '/member/register/general/confirm-info',
  /** 會員中心-會員註冊-一般註冊-確認資料 (Step-3-2) (page) */
  MEMBER__REGISTER__GENERAL__CONFIRM_INFO__OTP_AUTH = '/member/register/general/confirm-info/otp-auth',
  /** 會員中心-會員註冊-啟用網路投保權限 (module) */
  MEMBER__REGISTER__PERMISSION = '/member/register/permission',
  /** 會員中心-會員註冊-啟用網路投保權限-同意相關告知事項 (Step-1) (page) */
  MEMBER__REGISTER__PERMISSION__CLAUSES = '/member/register/permission/clauses',
  /** 會員中心-會員註冊-啟用網路投保權限-確認資料 (Step-2-1) (page) */
  MEMBER__REGISTER__PERMISSION__CONFIRM_INFO = '/member/register/permission/confirm-info',
  /** 會員中心-會員註冊-啟用網路投保權限-確認資料 (Step-2-2) (page) */
  MEMBER__REGISTER__PERMISSION__CONFIRM_INFO__OTP_AUTH = '/member/register/permission/confirm-info/otp-auth',
  /** 會員中心-會員資料 (page) */
  MEMBER__PROFILE = '/member/profile',
  /** 會員中心-會員資料修改 (module) */
  MEMBER__SETTINGS = '/member/settings',
  /** 會員中心-會員資料修改-變更密碼 (module) */
  MEMBER__SETTINGS__PASS_PHRASE = '/member/settings/pass-phrase',
  /** 會員中心-會員資料修改-變更密碼 (Step-1) (page) */
  MEMBER__SETTINGS__PASS_PHRASE__AUTH = '/member/settings/pass-phrase/auth',
  /** 會員中心-會員資料修改-變更密碼 (Step-2) (page) */
  MEMBER__SETTINGS__PASS_PHRASE__SETUP = '/member/settings/pass-phrase/setup',
  /** 會員中心-會員資料修改-變更手機號碼 (module) */
  MEMBER__SETTINGS__MOBILE = '/member/settings/mobile',
  /** 會員中心-會員資料修改-變更手機號碼 (Step-1) (page) */
  MEMBER__SETTINGS__MOBILE__AUTH = '/member/settings/mobile/auth',
  /** 會員中心-會員資料修改-變更手機號碼 (Step-2-1) (page) */
  MEMBER__SETTINGS__MOBILE__SETUP = '/member/settings/mobile/setup',
  /** 會員中心-會員資料修改-變更手機號碼 (Step-2-2) (page) */
  MEMBER__SETTINGS__MOBILE__SETUP__OTP_AUTH = '/member/settings/mobile/setup/otp-auth',
  /** 會員中心-會員資料修改-變更電子信箱 (module) */
  MEMBER__SETTINGS__EMAIL = '/member/settings/email',
  /** 會員中心-會員資料修改-變更電子信箱 (Step-1) (page) */
  MEMBER__SETTINGS__EMAIL__AUTH = '/member/settings/email/auth',
  /** 會員中心-會員資料修改-變更電子信箱 (Step-2-1) (page) */
  MEMBER__SETTINGS__EMAIL__SETUP = '/member/settings/email/setup',
  /** 會員中心-會員資料修改-變更電子信箱 (Step-2-2) (page) */
  MEMBER__SETTINGS__EMAIL__SETUP__OTP_AUTH = '/member/settings/email/setup/otp-auth',
  /** 會員中心-忘記密碼 (module) */
  MEMBER__FORGET = '/member/forget',
  /** 會員中心-忘記密碼-輸入基本資料 (Step-1-1) (page) */
  MEMBER__FORGET__AUTH = '/member/forget/auth',
  /** 會員中心-忘記密碼-輸入基本資料 (Step-1-2) (page) */
  MEMBER__FORGET__AUTH__OTP_AUTH = '/member/forget/auth/otp-auth',
  /** 會員中心-忘記密碼-設定新密碼 (Step-2) (page) */
  MEMBER__FORGET__SETUP = '/member/forget/setup',
  /** 會員中心-重新驗證身分 (module) */
  MEMBER__REAUTH = '/member/reauth',
  /** 會員中心-重新驗證身分-同意相關告知事項 (page) */
  MEMBER__REAUTH__CLAUSES = '/member/reauth/clauses',
  /** 會員中心-重新驗證身分-驗證身分 (page) */
  MEMBER__REAUTH__OTP_AUTH = '/member/reauth/otp-auth',

  /** 404頁面 */
  PAGE_ERROR_404 = '/404',
  /** 404頁面 */
  PAGE_ERROR_500 = '/500'
}
